import React from "react";
import { css } from "react-emotion";
import { withRedux } from "helpers";

const clickActionStyle = css`
  border: 1px solid transparent;
  &:hover {
    border-color: white;
  }
`;

const emptyClickActionStyle = css`
  z-index: 2;
  &:hover {
    cursor: pointer;
    /* border: 2px solid red; */
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
class TextComponent extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    let {
      actions: { updateActiveEditor },
      componentNumber,
    } = this.props;

    if (componentNumber) {
      updateActiveEditor(componentNumber);
    }
  }

  componentWillUnmount() {
    let { activeEditor } = this.props;

    if (activeEditor) {
      this.props.actions.refreshActiveEditor();
    }
  }

  render() {
    let {
      alignment,
      backgroundColor,
      bold,
      clickAction,
      font,
      fontSize,
      italics,
      text,
      textColor,
      underline,
      setTemplate,
    } = this.props;
    // console.log(text);
    const textAlign = ["left", "center", "right"][alignment];
    const hasClickAction = clickAction && clickAction.templateId;
    const parsedText = text.replace(/\\n/g, "\n");

    return (
      <div
        style={{
          fontSize,
          color: textColor,
          textDecoration: `${!!underline ? "underline" : ""}`,
          fontWeight: `${!!bold ? "bold" : ""}`,
          fontStyle: `${!!italics ? "italic" : ""}`,
          fontFamily: `${!!font ? font : ""}`,
          textAlign,
          wordWrap: "break-word",
          position: "relative",
          cursor: `${hasClickAction ? "pointer" : ""}`,
          padding: "5px",
        }}
        className={hasClickAction ? clickActionStyle : emptyClickActionStyle}
        onClick={
          hasClickAction ? setTemplate(clickAction.templateId) : this.onClick
        }
      >
        {parsedText.split("\n").map((item, key) => {
          return (
            <React.Fragment key={key}>
              {item}
              <br />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

export default withRedux(TextComponent);
